import { config } from "shared/data";

export const AI_WIDGET_API_TIMEOUT_MS = 10_000;

export const AI_WIDGET_FETCH_API_ENDPOINT = `${config.abWidgetApi.host}/recommend/v2`;

export const AI_WIDGET_FETCH_LOG_PREFIX = "[AI Widget Fetch]";
